import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/39/thumb-landscape.jpg"

const Post39 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">FENDI／ピーカブー／34 x26 x11cm</span>  
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>FENDI（フェンディ）のアイコンバッグ PEEKABOO(ピーカブー)の名前を聞いた事がある、という方も多いのではないでしょうか？ピンとこないという方も、ぜひこの機会に人気のPEEKABOO(ピーカブー) について知ることでコーディネートの幅を増やしてみてください。<br></br>PEEKABOO(ピーカブー) ってどんなバッグ？<br></br>使い勝手はどうだろう？<br></br>どんなコーディネートに合うの？<br></br>そんな疑問にお答えし、今回は人気のピーカブーについて深く掘り下げていきます。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2>目次</h2>
        <p>
          <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80}>①PEEKABOO(ピーカブー)の名前の由来とは？</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80}>②7つのサイズ展開</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec3" smooth={true} duration={500} offset={-80}>③レザーの種類</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec4" smooth={true} duration={500} offset={-80}>④おすすめコーディネート</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec5" smooth={true} duration={500} offset={-80}>⑤まとめ</ScrollLink>
        </p>
      </div>        
      <figure className="img-small">
        <StaticImage src="../../images/posts/39/1.png" alt="FENDI（フェンディ）のアイコンバッグ「ピーカブー（Peekaboo）」10年続く人気の理由とは？"/>
        <span className="text-center">
          上部 左：ENDI／ミニピーカブー／23 x17 x11cm<br></br>
          上部 右：FENDI／ミニピーカブー／23 x18 x7cm<br></br>
          中央：FENDI／ピーカブーエックスライト／42 x30 x13cm<br></br>
          下部 左：FENDI／ピーカブー／40 x30 x16cm<br></br>
          下部 右：FENDI／ミニピーカブー／23 x18 x9cm<br></br>
        </span> 
      </figure>      
      <div name="sec1" className="text-two-cloumn">
        <h2>①PEEKABOO(ピーカブー)<br className="pc"></br>の名前の由来とは？</h2>
        <p>
          2009年に登場したPEEKABOO(ピーカブー)はフェンディ創業者夫妻の孫フェンディ家3代目当主「シルヴィア・フェンディ」によってデザインされました。<br></br>英語で「いないないばあ」を意味するPEEKABOO(ピーカブー)はシルヴィアが孫娘をあやしているときに思いついたデザインだそう。当初「いないないばあ」ってどんなデザインなの？と思いましたが、その名の通り一見シンプルな外見でありながら、バッグを開けるとカラフルな裏地が飛び出したり、リッチに作られた内側とシンプルな外見のギャップがその名の通り大人の遊び心をくすぐるデザインです。
        </p>
      </div>
      <div name="sec2" className="text-two-cloumn">
        <h2>②7つのサイズ展開</h2>
        <p>
          誕生から10年を経て「ピーカブー」は、ライフスタイルに合わせたサイズ展開や、デザインのバリエーションが豊富です。2019年にはピーカブーがさらに進化を遂げたと言われている新ライン、間仕切りのないトート感覚の「エックスライト」も登場しました！
        </p>
      </div>       
      <div className="text-max-width">
        <h2>1.ピーカブーエックスライト ラージ /42x30x13cm(幅x高さxマチ)</h2>
        <p>中央のバーフレームを取り払ったことにより軽量化を図った、大ぶりな上質トップハンドルトートタイプです。<br></br>とにかく軽い！（個人の感想です）ビッグシルエットながらエレガントで◎書類などのお仕事アイテムもしっかり収納できますね！</p>
      </div>           
      <figure className="img-small">
        <StaticImage src="../../images/posts/39/2.png" alt=""/>
      </figure>  
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/39/3.jpg" alt=""/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/39/4.jpg" alt=""/>
        </figure>
      </div>                
      <Link to="https://laxus.co/app/pc/bags/fendi" className="view-all-button">
      フェンディのバッグを見る
      </Link>
      <div className="text-max-width">
        <h2>2.ピーカブーエックスライト ミディアム /30x25x13cm(幅x高さxマチ）</h2>
        <p>こちらは「エックスライト」シリーズのミディアムサイズ。かけ心地の良いファブリック製の取り外し可能なショルダーストラップをつけてカジュアルなコーディネートに合わせても◎</p>
      </div>     
      <figure className="img-small">
        <StaticImage src="../../images/posts/39/5.png" alt=""/>
      </figure>  
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/39/6.jpg" alt=""/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/39/7.jpg" alt=""/>
        </figure>
      </div>
      <span className="text-center">
        旬の厚底ショートブーツでカジュアルコーデに。
      </span>                    
      <figure className="img-small">
        <StaticImage src="../../images/posts/39/8.png" alt=""/>
      </figure>
      <div className="text-max-width">
        <h2>3.ピーカブー アイコニックエッセンシャル /27x16x11cm(幅x高さxマチ)</h2>
        <p>一枚革で表も裏も継ぎ目なく、レザーの美しさが際立つ上質シンプルデザインが特徴です。頑丈な間仕切りでふたつのコンパートメントに。表も裏も独自にツイストロック開閉可能です。裏の内側にはジップポケットがあり、脇のスナップを外ぜば、開口部が広がります。</p>
      </div>      
      <figure className="img-small">
        <StaticImage src="../../images/posts/39/9.png" alt=""/>
      </figure>  
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/39/10.jpg" alt=""/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/39/11.jpg" alt=""/>
        </figure>
      </div>                       
      <Link to="https://laxus.co/app/pc/bags/fendi" className="view-all-button">
      フェンディのバッグを見る
      </Link>
      <div className="text-max-width">
        <h2>4.ピーカブー アイコニックエッセンシャリ― /26x22x11cm(幅x高さxマチ)</h2>
        <p>ステッチが目立たないように縫い上げた、やわらかな一枚レザーのバッグは高級感がありどんなコーデとも好相性。</p>
      </div>      
      <figure>
        <StaticImage src="../../images/posts/39/12.jpg" alt=""/>
      </figure>  
      <figure>
        <StaticImage src="../../images/posts/39/13.jpg" alt=""/>
      </figure>  
      <figure className="img-small">
        <StaticImage src="../../images/posts/39/14.jpg" alt=""/>
      </figure> 
      <div className="text-max-width">
        <h2>5.ピーカブー アイシーユーミディアム（左）/31x24x11cm(幅x高さxマチ)<br></br>ピーカブーレギュラー（右）/34x26x11cm(幅x高さxマチ)</h2>
        <p>定番サイズミディアムは、レギュラーとも言われピーカブーの象徴的なサイズです。ハンドバッグとしても、ショルダーバッグとしても持つ事が可能で、実用的なサイズ感が人気の秘密のようです。パーテーション部分のデザインもポイントになっていてステキですね。</p>
      </div>  
      <figure>
        <StaticImage src="../../images/posts/39/15.jpg" alt=""/>
      </figure>
      <div className="img-two-cloumn">
        <figure>
          <StaticImage src="../../images/posts/39/16.jpg" alt=""/>
        </figure> 
        <figure>
          <StaticImage src="../../images/posts/39/17.jpg" alt=""/>
        </figure>
      </div>
      <div className="text-max-width">
        <h2>6.ピーカブー ミニ /23x15x10cm(幅x高さxマチ)</h2>
        <p>小さいながらも手持ちとショルダーの2wayでの使用が可能で、コーデの完成度を高めてくれるバッグ♡長財布も入るので、普段のお出かけにぴったりのサイズ感です。</p>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/39/18.png" alt=""/>
      </figure>  
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/39/19.jpg" alt=""/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/39/20.jpg" alt=""/>
        </figure>
      </div>
      <div className="text-max-width">
        <h2>7.マイクロピーカブー /15x11x5cm(幅x高さxマチ)</h2>
        <p>かなりコンパクトなマイクロはアクセサリーバッグとして◎</p>
      </div> 
      <figure className="img-small">
        <StaticImage src="../../images/posts/39/21.png" alt=""/>
      </figure> 
      <figure>
        <StaticImage src="../../images/posts/39/22.jpg" alt=""/>
      </figure>
      <Link to="https://laxus.co/app/pc/bags/fendi" className="view-all-button">
      フェンディのバッグを見る
      </Link>
      <div name="sec3" className="text-two-cloumn">
        <h2>③レザーの種類</h2>
        <p>
          PEEKABOO(ピーカブー)には、2種類のレザーが使用されています。バッグを選ぶ上で、重要な素材感。用途や好みにもよりますが、レザーの種類でもかなり雰囲気が変わります。それぞれの特徴を見比べてみましょう。
        </p>
      </div>
      <div className="text-max-width">
        <h2>■スムースレザー(牛革)</h2>
        <p>スムースレザーとは、「表面が滑らかな革」の総称です。動物の種類は関係なく、仕上がりの状態で分類されます。こちらは、カーフ（牛革)が使用されています。カーフレザーとは、生後6ヶ月以内の子牛から取れた革です。他の牛革と比べると、肌目が細かくて柔らかいのが特徴。しなやかな光沢感はエレガントで上品な印象となります。改めて、カーフレザーのお話を初めて聞かれた方には衝撃かも知れませんが、食用に育てられた子牛の革を使用しています。バッググラウンドを知るとより長く大切にバッグを使いたいですよね！</p>
      </div>
      <figure>
        <StaticImage src="../../images/posts/39/23.jpg" alt=""/>
      </figure> 
      <div className="text-max-width">
        <h2>■ナッパレザー</h2>
        <p>本来は柔らかさと耐久性が特徴の山羊革（または羊革）のことを指します。(※現在では、柔らかい革の総称として牛革であってもナッパレザーと呼ばれています)<br></br>揉んでシボをつけており、スムースレザーと比べて光沢は控えめです。（写真はカーフレザー使用）シボが大きめなのでキズが目立ちにくカジュアルシーンに使いやすいバッグとよく言われます。<br></br>特に、セレリアシリーズは、最高級のカーフレーザー「クオイオローマ」を使用し熟練の職人がハンドステッチを施し仕立てています。<br></br>「セレリアシリーズ」は一度は手にしてみたい、大人の憧れバッグですね。</p>
      </div>
      <figure>
        <StaticImage src="../../images/posts/39/24.jpg" alt=""/>
      </figure>
      <div name="sec4" className="text-max-width">
        <h2>④おすすめコーディネート</h2>
        <p>エレガントなキレイめコーディネートにはスムースレザーのミディアム。お仕事にも、お出かけにも！</p>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/39/25.png" alt=""/>
        <span className="text-center">FENDI／ピーカブー／40 x30 x16cm</span>  
      </figure> 
      <p className="text-max-width">
        カジュアルな普段使いには型押しレザーのミニ。トレンドカラーパンツに合わせても◎
      </p>
      <figure className="img-small">
        <StaticImage src="../../images/posts/39/26.png" alt=""/>
        <span className="text-center">FENDI／ミニピーカブー／23 x18 x11cm</span>  
      </figure>
      <div name="sec5" className="text-two-cloumn">
        <h2>⑤まとめ</h2>
        <p>
          いかがでしたでしょうか？<br></br>登場から10年を過ぎ、豊富なサイズ、カラー展開のPEEKABOO(ピーカブー)は、シンプルな大人女子に人気のバッグ。トレンドにも左右されず普段使いだけでなくビジネスシーンにも使える品の良さで、どんなシーンにもお持ちいただけます。あなたはどのサイズを選びますか？
        </p>
      </div>
      <Link to="https://laxus.co/app/pc/bags/fendi" className="view-all-button">
      フェンディのバッグを見る
      </Link>                                           
    </section>
    <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post39

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 39}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
